import React, { useCallback, useMemo, useState } from 'react';
import usePagination from '../../../../hooks/usePagination';
import PaginationBlock from '../ui/PaginationBlock/PaginationBlock';

let initPageSize = 10;

const useTablePagination = (data = []) => {
  const [pageSize, setPageSize] = useState(initPageSize);

  const [currentPageNumber, setCurrentPageNumber, maxPage, shownItems] =
    usePagination(data, pageSize);

  const handlePageSizeChange = useCallback((newPageSize) => {
    setPageSize(newPageSize);
    initPageSize = newPageSize;
  }, []);

  const handlePageChange = useCallback(
    (page) => {
      const pageNum = page - 1;

      setCurrentPageNumber(pageNum);
    },
    [setCurrentPageNumber]
  );

  const pagination = useMemo(
    () => (
      <PaginationBlock
        currentPageNumber={currentPageNumber}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        pageSize={pageSize}
        total={data?.length || 0}
        showQuickJumper={maxPage > 9}
      />
    ),
    [
      pageSize,
      currentPageNumber,
      handlePageChange,
      handlePageSizeChange,
      maxPage,
      data,
    ]
  );

  return {
    shownItems,
    pagination,
  };
};

export default useTablePagination;
